import { render, staticRenderFns } from "./QuickSetupModal.vue?vue&type=template&id=51684f20&lang=pug&"
import script from "./QuickSetupModal.vue?vue&type=script&lang=js&"
export * from "./QuickSetupModal.vue?vue&type=script&lang=js&"
import style0 from "./QuickSetupModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports